import styled from "@emotion/styled";
import { Caps2BoldTypography } from "../../primitives/Typography/typographyVariants";
import { NumberPillProps } from "./NumberPill.types";

export const NumberPillContainer = styled.div<NumberPillProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${(props) => props.minWidth || "auto"};
  min-height: ${(props) => props.minHeight || "16px"};
  padding: ${(props) => props.py || "2px"} ${(props) => props.px || "4px"};
  background-color: ${(props) => props.backgroundColor || "#EF4444"};
  border-radius: ${(props) => props.borderRadius || "50%"};
  ${(props) =>
    props.showBorder
      ? `border: ${props.borderWidth || "1px"} solid ${
          props.borderColor || "#FFFFFF"
        };`
      : "border: none;"}
  position: ${(props) => props.position || "static"};
  ${(props) => props.top && `top: ${props.top};`}
  ${(props) => props.right && `right: ${props.right};`}
  ${(props) => props.bottom && `bottom: ${props.bottom};`}
  ${(props) => props.left && `left: ${props.left};`}
  ${(props) => props.zIndex && `z-index: ${props.zIndex};`}
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  user-select: none;
  -webkit-user-select: none;
`;

export const NumberPillText = styled(Caps2BoldTypography)<{
  textColor?: string;
  fontSize?: string;
  fontWeight?: string | number;
}>`
  color: ${(props) => props.textColor || "#FFFFFF"};
  font-size: ${(props) => props.fontSize || "10px"};
  font-weight: ${(props) => props.fontWeight || 700};
  line-height: ${(props) => props.lineHeight || "1"};
  text-align: center;
  letter-spacing: 0;
  white-space: nowrap;
`;
